// extracted by mini-css-extract-plugin
export var hidden = "_tm-0";